export default "__VITE_ASSET__86474ff6__"